
import { Box, Typography } from "@mui/material";

import type { WidgetProps } from "./types";

export function Image({ widget }: WidgetProps<"image">) {
    const { title, src, alt, caption, maxWidth } = widget.props;

    return (
        <Box>
            {title && (
                <Typography variant="h3" sx={{ mb: 2 }}>
                    {title}
                </Typography>
            )}
            <Box sx={{ textAlign: "center" }}>
                <Box
                    component="img"
                    src={src}
                    alt={alt}
                    sx={{
                        display: "block",
                        maxWidth: maxWidth ? `${maxWidth}px` : "100%",
                        width: "100%",
                        height: "auto",
                        mx: "auto",
                    }}
                />
                {caption && (
                    <Typography
                        variant="body2"
                        sx={{ mt: 1.5, color: "text.secondary" }}
                    >
                        {caption}
                    </Typography>
                )}
            </Box>
        </Box>
    );
}
